import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DiaryUtils } from '../../../../../../../../data/tracker/domain/diary/diary_type';
import { DiaryType } from '../../../../../../../../data/tracker/domain/diary_type/diary_type';
import { DiaryTypeUtils } from '../../../../../../../../data/tracker/domain/diary_type/diary_type_utils';
import { TrackerType } from '../../../../../../../../data/tracker/domain/tracker/tracker_type';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[msd-custom-tracker-cell]',
  templateUrl: './custom-tracker-cell.component.html',
  styleUrls: ['./custom-tracker-cell.component.scss'],
})
export class CustomTrackerCellComponent implements OnInit {
  @Input() diaryTypes: DiaryType[];
  @Input() diaryType: string;
  @Input() name: string;
  @Input() maxValue: number;
  @Input() type: TrackerType;
  @Input() actionLoading = false;
  @Output() onDelete = new EventEmitter();

  public diaryUtils: DiaryUtils;

  constructor() {
    // Nada
  }

  ngOnInit(): void {
    this.diaryUtils = new DiaryTypeUtils();
  }

  get diaryTypeLabel(): string {
    return this.diaryTypes.filter((d) => d.name === this.diaryType)[0].label;
  }

  get valueFormatted(): string {
    switch (this.type) {
      case TrackerType.Note:
        return `Note de 0 à ${this.maxValue}`;
      case TrackerType.Number:
        return `Nombre de 0 à ${this.maxValue}`;
      case TrackerType.Percent:
        return `Pourcentage de 0 à ${this.maxValue}`;
      default:
        break;
    }
    return '';
  }

  public offsetDropdown(bAct: HTMLButtonElement, height: number): boolean {
    const pos = bAct.getBoundingClientRect();
    return window.innerHeight - (pos.top + window.scrollY) - height < 0;
  }
}
